import React, { lazy, Suspense } from "react";
import "./jackpot-banner.scss";
import Modal from "react-modal";
import LoaderContainer from "../../../mui/loader_container/LoaderContainer";

const JackpotBannerContent = lazy(() => import("./jackpotWinBannerDesktop"));

export default function JackpotBanner({ isOpen, jackpot, closeModal }) {
  return (
    <Modal
      ariaHideApp={false}
      className={"jackpot-banner-modal"}
      isOpen={isOpen}
      shouldFocusAfterRender={false}>
      <Suspense fallback={<LoaderContainer center loader />}>
        <JackpotBannerContent
          amount={jackpot?.amount}
          currency={jackpot?.currency}
          tier={jackpot?.type?.toLocaleLowerCase()}
          onClick={closeModal}
        />
      </Suspense>
    </Modal>
  );
}
